module.exports = __webpack_public_path__ + "cf.aaa41b8c9f488b69b7a0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cf.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cf.svg
// module chunks = styles